const chartNames = {
  PAGE_LOADS: "page_loads",
  AVG_PAGE_LOAD_SPEED: "avg_page_load_speed",
  CONNECTION_TIME: "connection_time",
  IQOS_DEVICE_USAGE: "iqos_device_usage",
  IQOS_DEVICE_CONNECTIONS_COUNT: "iqos_device_connections_count",
  BROWSER: "browser",
  OS: "os",

  DIAGNOSTICS_PERFORMANCE: "diagnostics_performance",
  AD_STATISTICS: "ad_statistics",
  AD_COUNT: "ad_count",
  DIAGNOSTICS_ERRORS_READING_PERFOMANCE: "diagnostic_errors_reading_perfomance",

  FWU_STATISTICS: "fwu_statistics",
  FWU_PERFORMANCE: "fwu_performance",
  FWU_ERRORS: "fwu_errors",
  FWU_COUNT: "fwu_count",
  RECONNECTION_TIME_DURING_FWU: "reconnection_time_during_FWU",

  SETTING_USAGE: "setting_usage",
  SETTING_PERFOMANCE: "setting_perfomance",

  BATTERY_HEALTH_STATISTICS: "battery_health_statistics",
  BATTERY_HEALTH_PERFORMANCE: "battery_health_performance"
};

export default chartNames;
